import Seo, { orgLd, faqLd } from "@/components/site/Seo";
import Hero from "@/components/home/Hero";
import { PromoBanner } from "@/components/home/PriceStrip";
import PortfolioCarousel from "@/components/home/PortfolioCarousel";
import PreviewCta from "@/components/home/PreviewCta";
import ServicesBento from "@/components/home/ServicesBento";
import PricingShowcase from "@/components/home/PricingShowcase";
import WhyProcess from "@/components/home/WhyProcess";
import FaqContact from "@/components/home/FaqContact";
import { HOME_FAQS } from "@/data/home";
import { HOME_SECTIONS } from "@/data/content";

const SECTIONS = { hero: Hero, promo: PromoBanner, portfolio: PortfolioCarousel, pricing: PricingShowcase, services: ServicesBento, why: WhyProcess, preview: PreviewCta, faq: FaqContact };

export default function Home() {
  return (
    <>
      <Seo path="/" title="STUDIO WEB NS — Siti web professionali da 490 € in tutta Italia"
        description="Creiamo e gestiamo siti web professionali per negozi, professionisti e imprese in tutta Italia. Prezzi chiari da 490 € + 39 €/mese IVA esclusa, hosting e manutenzione inclusi."
        jsonLd={[orgLd, faqLd(HOME_FAQS)]} />
      {HOME_SECTIONS.filter((s) => s.enabled).map(({ id }) => {
        const S = SECTIONS[id];
        return <S key={id} />;
      })}
    </>
  );
}
